export function resize() {
	// Tolerance (px) is the size a viewport can chance
	// before updating css variables this prevents jerky
	// resizing when browser chrome disappears on mobile
	const tolerance = 60;

	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${ vh }px`);
	let lastHeight = window.innerHeight;

	let vw = window.innerWidth * 0.01;
	document.documentElement.style.setProperty('--vw', `${ vw }px`);
	let lastWidth = window.innerWidth;

	document.documentElement.style.setProperty('--scroll', (window.pageYOffset));

	if (document.querySelector('.site-header')) {
		const headerHeight = document.querySelector('.site-header');
		let offsetHeight = 0;

		if (headerHeight) {
			offsetHeight = headerHeight.offsetHeight;
		} else {
			offsetHeight = 100;
		}
		document.documentElement.style.setProperty('--header-height', `${ offsetHeight }px`);
	}

	if (document.querySelector('.site-masthead__content')) {
		const mastheadContentHeight = document.querySelector('.site-masthead__content');
		let mastheadOffsetHeight = 0;

		if (mastheadContentHeight) {
			mastheadOffsetHeight = mastheadContentHeight.offsetHeight;
		} else {
			mastheadOffsetHeight = 100;
		}
		document.documentElement.style.setProperty('--masthead-content-height', `${ mastheadOffsetHeight }px`);
	}

	const resizeVars = () => {
		if (Math.abs(lastHeight - window.innerHeight) > tolerance) {
			vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${ vh }px`);
			lastHeight = window.innerHeight;
		}

		if (lastWidth !== window.innerWidth) {
			vw = window.innerWidth * 0.01;
			document.documentElement.style.setProperty('--vw', `${ vw }px`);
			lastWidth = window.innerWidth;
		}

		if (document.querySelector('.site-header')) {
			const headerHeight = document.querySelector('.site-header');
			let offsetHeight = 0;

			if (headerHeight) {
				offsetHeight = headerHeight.offsetHeight;
			} else {
				offsetHeight = 100;
			}
			document.documentElement.style.setProperty('--header-height', `${ offsetHeight }px`);
		}

		if (document.querySelector('.site-masthead__content')) {
			const mastheadContentHeight = document.querySelector('.site-masthead__content');
			let mastheadOffsetHeight = 0;
	
			if (mastheadContentHeight) {
				mastheadOffsetHeight = mastheadContentHeight.offsetHeight;
			} else {
				mastheadOffsetHeight = 100;
			}
			document.documentElement.style.setProperty('--masthead-content-height', `${ mastheadOffsetHeight }px`);
		}
	};
	const scrollVars = () => {
		document.documentElement.style.setProperty('--scroll', (window.pageYOffset));
		const siteMasthead = document.querySelector(".site-masthead");
		if (siteMasthead) {
			if (window.pageYOffset > siteMasthead.clientHeight) {
				document.body.classList.add("attach-fixed-button")
			} else {
				document.body.classList.remove("attach-fixed-button")
			}

		}
	}
	window.addEventListener('resize', () => {
		resizeVars();
	});
	window.addEventListener('scroll', ()=> {
		scrollVars();

	})
	setTimeout(function() {
		resizeVars();
		scrollVars();
	}, 100);
}

